import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root_1 = $.from_html(`<button> </button>`);
var root = $.from_html(`<div class="segmented svelte-27vcrodyuf0z9"></div>`);

function SegmentedControl($$anchor, $$props) {
	$.push($$props, true);

	var div = root();

	$.each(div, 21, () => $$props.options, $.index, ($$anchor, option) => {
		var button = root_1();
		let classes;
		var text = $.child(button, true);

		$.reset(button);

		$.template_effect(() => {
			classes = $.set_class(button, 1, 'segment svelte-27vcrodyuf0z9', null, classes, { active: $$props.selected === $.get(option).value });
			$.set_text(text, $.get(option).label);
		});

		$.delegated('click', button, () => $$props.onchange($.get(option).value));
		$.append($$anchor, button);
	});

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	SegmentedControl = $.hmr(SegmentedControl);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-27vcrodyuf0z9');
		SegmentedControl[$.HMR].update(module.default);
	});
}

export default SegmentedControl;

$.delegate(['click']);
import "bun-svelte:SegmentedControl.svelte-sjublhqo1o16-style.css";